module.exports = __webpack_public_path__ + "static/media/header.79c57d46.png";